const landing_page = {
  aboutUs: "เกี่ยวกับเรา", // translated
  topPackages: "แพ็คเกจยอดนิยม", // translated
  featuredHotels: "โรงแรมเด่น", // translated
  topTours: "ทัวร์ยอดนิยม", // translated
  whatOurMembersSay: "สมาชิกของเราว่าอย่างไร...", // translated
  followUsOnInstagram: "ติดตามเราบนอินสตาแกรม", // translated
  pleaseWait: "โปรดรอ...", // translated
  packages: "แพ็คเกจ", // translated
  ourPartners: "พันธมิตรของเรา", // translated
  trustedCarHirePartners: "พันธมิตรรถเช่าที่เชื่อถือได้", // translated
  learnMore: "เรียนรู้เพิ่มเติม", // translated
};


export default landing_page;
